import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableSessionsReportView.
 * @extends JetView
 */
export default class tableSessionsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        // Extending the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        // Returning the layout configuration
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            footer: true, // Enable footer
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the DataTable
                                {
                                    id: 'SessionId', // Column ID
                                    header: _('ID Sesión'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: 'Total:', // Footer content
                                },
                                {
                                    id: 'PlayerId',
                                    header: _('ID Usuario'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'StartTime',
                                    header: _('Hora Inicio'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'EndTime',
                                    header: _('Hora Fin'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Geolocation',
                                    header: _('Geolocalización'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'AmountWagered',
                                    header: _('Monto Apostado'),
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type for this column
                                },
                                {
                                    id: 'AmountEarned',
                                    header: _('Monto Ganado'),
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'PromCreditsReceived',
                                    header: _('Creditos Promocionales Recibidos'),
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'PromCreditsWagered',
                                    header: _('Creditos Promocionales Apostados'),
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TypeClosed',
                                    header: _('Motivo Cierre'),
                                    options: [
                                        // Options for the TypeClosed column
                                        { id: '', value: _('None') },
                                        { id: 'M', value: _('Manual') },
                                        { id: 'A', value: _('Automático') },
                                        { id: 'S', value: _('Sistema') },
                                    ],
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'SaldoStart',
                                    header: _('Saldo al Iniciar'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'SaldoEnd',
                                    header: _('Saldo al Final'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                            ],
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            data: [
                                // Sample data for the DataTable
                                {
                                    SessionId: '25',
                                    PlayerId: '136',
                                    StartTime: '5:05:12',
                                    EndTime: '6:05:51',
                                    Geolocation: 'Ecuador',
                                    AmountWagered: '325',
                                    AmountEarned: '354',
                                    PromCreditsReceived: '520',
                                    PromCreditsWagered: '586',
                                    TypeClosed: 'A',
                                    SaldoStart: '300',
                                    SaldoEnd: '254',
                                },
                                {
                                    SessionId: '26',
                                    PlayerId: '136',
                                    StartTime: '6:05:34',
                                    EndTime: '8:05:52',
                                    Geolocation: 'Ecuador',
                                    AmountWagered: '1325',
                                    AmountEarned: '554',
                                    PromCreditsReceived: '120',
                                    PromCreditsWagered: '586',
                                    TypeClosed: 'S',
                                    SaldoStart: '399',
                                    SaldoEnd: '122',
                                },
                            ],
                            ready: function () {
                                // Event handler for when the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no data entries
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            pager: 'pagerA', // ID for the pager component
                            // URL for fetching data
                            url: devConfig.geturlApi() + 'null/Report/getSessions',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the DataTable instance
        var url = grid.data.url; // URL for data fetching
        var filter = ''; // Variable to hold filter parameters

        // Event listener for filtering session reports
        this.on(this.app, 'sessionReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to hold query parameters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filtering
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object type filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the DataTable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data filtered by selected player ID
            );
        });
    }
}

// FILE DOCUMENTED
